module.exports = __webpack_public_path__ + "static/PVD-00fdabd588ad88d824644da22e70f92e.jpg";